import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list (params) {
    const options = {
        params: params,
        paramsSerializer: function (params) {
            return qs.stringify(params, { encode: false });
        }
    };

    return axios.get(`${url}/vouchers`, options)
        .then(response => {
            console.log('REQUEST:', params);
            console.log('API DATA LENGTH:', response.data.data.length);
            console.log('API META:', response.data.meta);
            console.log('API DATA:', response.data.data);
            return {
                list: jsona.deserialize(response.data),
                meta: response.data.meta
            };
        });
}

function get(id) {
    const options = {
        headers: {
            Accept: 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        },
    };

    return axios.get(
        `${url}/vouchers/${id}?include=
        vendor,
        invoices.department.port.station,
        statuses,
        statuses.creator`
            .replace(/\s+/g, ''),
        options
    )
        .then(response => {
            let voucher = jsona.deserialize(response.data);
            delete voucher.links;
            return voucher;
        });
}

function add (voucher) {
    const payload = jsona.serialize({
        stuff: voucher,
        includeNames: null
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/vouchers`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function update (voucher) {
    console.log(voucher);
    const payload = jsona.serialize({
        stuff: voucher,
        includeNames: []
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.patch(`${url}/vouchers/${voucher.id}`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function destroy (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.delete(`${url}/vouchers/${id}`, options);
}
function execute (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/voucher/execute/${id}`, options)
        .then(response => {
            let voucher = jsona.deserialize(response.data);
            // delete voucher.links;
            // console.log(voucher)
            return voucher;
        });
}
function update1 (voucher) {
    const payload = jsona.serialize({
        stuff: voucher,
        includeNames: []
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.patch(`${url}/voucher/status/${voucher.id}`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}
function getStatusStatistics (params) {
    let options = {
        params: params,
        paramsSerializer: function (params) {
            return qs.stringify(params, { encode: false });
        },
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        },
    };

    return axios.get(`${url}/vouchers/status/stats`, options)
        .then(response => {
            console.log(response.data.data);
            return response.data.data ? response.data.data : [];
        });
}
function forceReject(id, force_reject) {
    return axios.patch(`${url}/vouchers/${id}/force-reject`, {
        force_reject: force_reject,
    }).then(response => {
        return response.data;
    });
}
function getDashboard(filters = {}) {

    return axios.get(
        `${url}/voucher-dashboard`,
        {
            params: filters
        }
    );
}


export default {
    list,
    get,
    add,
    update,
    destroy,
    execute,
    update1,
    getDashboard,
    getStatusStatistics,
    forceReject
};

